<template>
  <!-- 表格内的文件列组件 多处用到,没有都复用后续可以复用...-->
  <div class="file-column">
    <span v-if="formatPicData(data).length === 0">-</span>
    <div class="file-list" v-else>
      <el-tooltip ref="tooltip" popper-class="file-tooltip file-dropdown-picture" transition="''" :visible-arrow="false" class="file-name" placement="bottom" v-if="formatPicData(data).length === 1">
        <div class="title" slot="content">
          <div class="down" @click.stop="downFile(formatPicData(data)[0])">
            <i class="el-icon-download"></i>
            <span>下载</span>
          </div>
          <div class="external-link-preview" v-if="hasNewWindow(formatPicData(data)[0])" @click.stop="externalLinkPreview(formatPicData(data)[0])">
            <i></i><span>新窗口预览</span>
          </div>
          <div class="preivew" @click.stop="preivewFile(formatPicData(data)[0])">
            <i class="el-icon-view"></i>
            <span>预览</span>
          </div>
        </div>
        <div class="one-file">{{formatPicData(data)[0].name}}</div>
      </el-tooltip>
      <el-dropdown placement="bottom" v-else>
        <span class="el-dropdown-link">
          <span class="multiple-accessory">{{formatPicData(data)[0] && formatPicData(data)[0].name}}</span> ( {{ getFileLength(data) }} )<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu ref="uploadDropdownMenu" class="rc-file-dropdown table-dropdown el-dropdown-rc-file-dropdown-picture" slot="dropdown">
          <el-dropdown-item
            v-for="(pic,index) in formatPicData(data)"
            :command="pic.link"
            :key="index">
            <a class="item" :title="pic.name">{{pic.name}}</a>
            <div class="preivew-or-down picture-upload">
              <div class="down" @click.stop="downFile(pic)">
                <i class="el-icon-download"></i><span>下载</span>
              </div>
              <div class="external-link-preview" v-if="hasNewWindow(pic)" @click.stop="externalLinkPreview(pic)">
                <i></i><span>新窗口预览</span>
              </div>
              <div class="preivew" @click.stop="preivewFile(pic)">
                <i class="el-icon-view"></i><span>预览</span>
              </div>
              <div class="pack-down-all" @click.stop="packDown">
                <i></i><span>打包下载</span>
              </div>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--图片预览-->
    <PicturePreview ref="picturePreview" @closePreview="closePreview" :coverPicList="coverPicList" v-if="swiperFlag" :src="previewFileSrc"></PicturePreview>
  </div>
</template>

<script>
import JSZip from 'jszip'
import PicturePreview from '@/components/form/runtime/components/picture-preview-swiper.vue'
export default {
  name: 'file-column',
  props: {
    data: String, // $.$形式的文件字符串
    column: Object
  },
  data () {
    let symbolKey = String(Symbol(new Date().valueOf()))
    return {
      coverPicList: [],
      swiperFlag: false,
      previewFileSrc: '',
      symbolKey
    }
  },
  created () {
    window.addEventListener('beforeunload', this.removeSymbolKey, false)
    window.addEventListener('load', this.removeSymbolKey, false)
  },
  components: {
    PicturePreview
  },
  methods: {
    formatPicData (data) {
      let array = []
      if (data) {
        data.split('$.$').forEach(m => {
          if (m) {
            array.push({'name': m.split(',/')[0], 'link': m.slice(m.indexOf(',/') + 1), 'url': m.slice(m.indexOf(',/') + 1)})
          }
        })
      }
      return array
    },
    // 获取二进制文件
    getFile (file) {
      let url = ''
      if (file.link.includes('http')) {
        url = file.link
      } else {
        url = `${location.origin}/shared-api/files/download?data=${encodeURIComponent('$.$')}${encodeURIComponent(file.name)},${file.link}`
      }
      return this.$axios.get(url, {responseType: 'blob'})
    },
    downFile (file) {
      this.getFile(file).then(res => {
        const url = window.URL.createObjectURL(res.data)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    preivewFile (item) {
      // 非 doc、docx、xls、xlsx 走 view 接口
      if (item.link) {
        // 点击预览 关闭列表
        this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.hide()
        if (this.$refs && this.$refs.tooltip) {
          this.$refs.tooltip.showPopper = false
        }
        let src = item.link
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: item.name}}).href
          window.open(href, '_blank')
        } else if (['png', 'jpg', 'jpeg', 'gif'].includes(type)) {
          //  55th:所有租户用新预览
          this.redCatPreviewPic(src)
          // let href = this.$router.resolve({name: 'imagePreview', query: {src: sessionStorage.getItem('ossDownloadUrl') + src, name: item.name}}).href
          // window.open(href, '_blank')
        } else if (['pdf', 'txt'].includes(type)) {
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
        } else {
          this.$message.info('暂不支持该类型文件预览！')
        }
      }
    },
    // 新标签页打开
    externalLinkPreview (item) {
      // 非 doc、docx、xls、xlsx 走 view 接口
      if (item.link) {
        // 点击预览 关闭列表
        this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.hide()
        if (this.$refs && this.$refs.tooltip) {
          this.$refs.tooltip.showPopper = false
        }
        let src = item.link
        let types = src.split('.')
        let type = types[types.length - 1].toLowerCase()
        let imageType = ['png', 'jpg', 'jpeg', 'gif']
        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(type)) {
          let href = this.$router.resolve({name: 'filePreview', query: {src, name: item.name}}).href
          window.open(href, '_blank')
        } else if (imageType.includes(type)) {
          // 过滤掉正在上传的其他文件，和非图片控件
          let fileList = this.formatPicData(this.data).filter(f => imageType.includes(f.name.split('.').pop().toLowerCase()))
          sessionStorage.setItem(this.symbolKey, JSON.stringify(fileList))
          let href = this.$router.resolve({name: 'imagePreview', query: {id: this.symbolKey, src}}).href
          window.open(href, '_blank')
        } else if (['pdf', 'txt'].includes(type)) {
          // pdf 与 txt 在ali oss文件系统上可以直接预览
          src.includes('http') ? window.open(src) : window.open(`${sessionStorage.getItem('ossDownloadUrl')}${src}`)
        } else {
          this.$message.info('暂不支持该类型文件预览！')
        }
      }
    },
    // 打包下载
    packDown () {
      let zip = new JSZip()
      let getFilePromiseArray = this.formatPicData(this.data).map(file => {
        return this.getFile(file).then(res => {
          zip.file(file.name, res.data, {binary: true})
        })
      })
      return Promise.all(getFilePromiseArray).then(() => {
        zip.generateAsync({
          type: 'blob'
        }).then(content => {
          let url = window.URL.createObjectURL(content)
          let vDom = document.createElement('a')
          vDom.style.display = 'none'
          vDom.href = url
          vDom.setAttribute('download', '下载的文件.zip')
          document.body.appendChild(vDom)
          vDom.click()
          document.body.removeChild(vDom)
          window.URL.revokeObjectURL(url)
        })
      })
    },
    getFileLength (files) {
      let array = files.split('$.$') || []
      return array && array.length ? array.filter(c => c && c).length : 0
    },
    redCatPreviewPic (src) {
      let allowType = ['png', 'jpg', 'jpeg', 'gif']
      this.coverPicList = this.formatPicData(this.data).filter((c, index) => {
        let type = c.name.split('.').pop()
        return !c.loading && allowType.some(n => n === type.toLocaleLowerCase())
      })
      this.previewFileSrc = src
      this.$nextTick(() => {
        this.swiperFlag = true
      })
    },
    closePreview () {
      this.swiperFlag = false
    },
    removeSymbolKey () {
      this.symbolKey && sessionStorage.removeItem(this.symbolKey)
    }
  },
  computed: {
    hasNewWindow () {
      return file => {
        let allowType = ['png', 'jpg', 'jpeg', 'gif']
        let type = file.link.split('.').pop()
        return allowType.some(n => n === type.toLocaleLowerCase())
      }
    }
  },
  beforeDestroy () {
    this.removeSymbolKey()
    window.removeEventListener('beforeunload', this.removeSymbolKey)
    window.removeEventListener('load', this.removeSymbolKey)
  }
}
</script>
<style lang="scss">
  .el-tooltip__popper.file-dropdown-picture {
    width: 98px;
    > .title {
      width: 98px;
      padding-left: 4px;
      .down, .preivew, > div {
        height: 21px;
        line-height: 21px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover{
          color: #4592E4;
        }
        i {
          font-size: 12px;
          margin-right: 5px;
        }
        span {
          font-size: 12px;
          display: inline-block;
          width: calc(100% - 10px);
          text-align: left;
        }
      }
      .pack-down-all {
        &:hover{
          color: #4592E4;
          >i{
            filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
          }
        }
        > i {
          display: inline-block;
          width: 12px;
          height: 12px;
          background: url("../../../form/runtime/components/assets/pack-download.png") no-repeat center;
        }
      }
      .external-link-preview {
        &:hover{
          color: #4592E4;
          >i{
            filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
          }
        }
        > i {
          display: inline-block;
          width: 12px;
          height: 12px;
          background: url("../../../form/runtime/components/assets/link.png") no-repeat center;
        }
      }
    }
  }
  .el-dropdown-menu.el-dropdown-rc-file-dropdown-picture {
    .el-dropdown-menu__item {
      .picture-upload {
        width: 98px;
        padding-left: 4px;
        .down, .preivew, > div {
          height: 21px;
          line-height: 21px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &:hover{
            color: #4592E4;
          }
          i {
            font-size: 12px;
            margin-right: 5px;
          }
          span {
            font-size: 12px;
            display: inline-block;
            width: calc(100% - 10px);
            text-align: left;
          }
        }
        .pack-down-all {
          &:hover{
            color: #4592E4;
            >i{
              filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
            }
          }
          > i {
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url("../../../form/runtime/components/assets/pack-download.png") no-repeat center;
          }
        }
        .external-link-preview {
          &:hover{
            color: #4592E4;
            >i{
              filter: invert(50%) sepia(94%) saturate(1170%) hue-rotate(188deg) brightness(93%) contrast(92%);
            }
          }
          > i {
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url("../../../form/runtime/components/assets/link.png") no-repeat center;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/tableComponents/file-column.vue